import { ApiResponse, TokenData, CancellationReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class ListPriceUploadRejectReasonService extends ApiService {
  public async loadAllReasons() {
    const url = `${this.apiDomain}/api/settings/vehicle/list-price/uploads/reject-reasons`;

    const resposne = await http.get<ApiResponse<CancellationReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createReason(data: CancellationReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/vehicle/list-price/uploads/reject-reasons`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async updateReason(data: CancellationReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/vehicle/list-price/uploads/reject-reasons/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteReason(id?: string) {
    const url = `${this.apiDomain}/api/settings/vehicle/list-price/uploads/reject-reasons/${id}`;

    const response = await http.remove<ApiResponse<CancellationReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
